import { m, LazyMotion, domAnimation } from 'framer-motion'
import { forwardRef } from 'react'

import CarouselCard from '../../carousel-card'

import styles from './index.module.scss'

// Animations
const ANIMATION_PROPS = {
  variants: {
    start: { y: '50%', opacity: 0 },
    end: {
      y: '0%',
      opacity: 1,
      transition: { type: 'spring', bounce: 0 },
    },
  },
  initial: 'start',
  whileInView: 'end',
  viewport: { once: true },
}

const TESTIMONIALS = [
  {
    text: "Olby gave me a whole new perspective on what I could expect for my career. The whole team is fantastic, and they're willing to help you with anything you may need in order to build a great path for yourself.",
    author: 'Luiz Gabriel Gusmão Santos',
    authorPosition: 'Software Engineer @ Loadsmart',
  },
  {
    text: 'I think having international experience was fundamental for my career and as a person. Getting to know new people, new cultures, different backgrounds and new points of view was something I was really looking forward to, and Olby helped me get there.',
    author: 'Arthur Moreira de Deus',
    authorPosition: 'Software Engineer @ Parade',
  },
  {
    text: "I've thought about applying for international jobs before, but before joining Olby, I thought it'd still take a couple of years before I actually had a shot. Since joining Olby I have learned a ton and with my current salary, my life has definitely taken a turn for the better.",
    author: 'Jorge Murakami',
    authorPosition: 'Software Engineer @ HighNote',
  },
  {
    text: 'There is a lot that comes with working for an international company and I feel like Olby guided me on every step. I definitely feel more secure knowing they are backing me up through the process.',
    author: 'Bruna Schmidt Nascimento',
    authorPosition: 'UX/UI Designer @ Benepass',
  },
  {
    text: 'For a long time, my goal was to work in an international company and Olby helped me to achieve that. Olby really made me feel safe during the entire process.',
    author: 'Leon Daros',
    authorPosition: 'Product Manager @ HighNote',
  },
]

export const ExpandYourConnections = forwardRef<HTMLElement>((_, ref) => (
  <section className={styles['section-wrapper']} ref={ref}>
    <div className={styles['content']}>
      <LazyMotion features={domAnimation} strict>
        <m.h2 className={styles['section-title']} {...ANIMATION_PROPS}>
          Expand your connections
        </m.h2>
        <m.p className={styles['section-description']} {...ANIMATION_PROPS}>
          With a bit of help you can reach for the stars. Join our community.
        </m.p>
        <m.div className={styles['carousel-container']} {...ANIMATION_PROPS}>
          <CarouselCard
            testimonials={TESTIMONIALS}
            picture="https://platform-statics.olby.com/talent-testimonials.png"
          />
        </m.div>
      </LazyMotion>
    </div>
  </section>
))

export default ExpandYourConnections
